import React from "react";
import ModalComponent from "../../../ModalComponent";

function Index({ handleOpenAboutPatient, handleCloseAboutPatient }) {
  return (
    <ModalComponent
      open={handleOpenAboutPatient}
      handleClose={handleCloseAboutPatient}
      closeBtn={true}
      confirmBtn={true}
      handleOk={null}
      title="AboutPatient Modal"
    ></ModalComponent>
  );
}

export default Index;
